import * as React from 'react';
import { useDroppable } from '@progress/kendo-react-common';

import { ListItem } from './ListItem';
import { List, ListProps } from './List';
import { DropContext, DragContext } from './WidgetsDroppableList';

export interface DroppableListProps extends ListProps {
  onDrop?: Function;
}

export const DroppableList = (props: DroppableListProps) => {
  const list = React.useRef<HTMLUListElement>(null);
  const dropInstance = React.useRef<{
    element: React.RefObject<HTMLElement | null>;
  }>(null);
  React.useImperativeHandle(dropInstance, () => ({
    element: list,
  }));

  const [drag] = React.useContext(DragContext);
  const [drop, setDrop] = React.useContext(DropContext);

  const handleDragEnter = () => {
    if (!props.children || !React.Children.count(props.children)) {
      setDrop(dropInstance.current);
    }
  };

  const handleDragLeave = () => {
    if (!props.children || !React.Children.count(props.children)) {
      setDrop(null);
    }
  };

  const handleDrop = () => {
    if (props.onDrop) {
      props.onDrop();
    }
  };

  useDroppable(list, {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
  });

  return (
    <List ref={list} {...props}>
      {props.children && React.Children.count(props.children)
        ? props.children
        : drag &&
          drop && (
            <ListItem style={{ opacity: '0.7' }}>{drag.data.name}</ListItem>
          )}
    </List>
  );
};
